import React from 'react'
import {browserHistory, Route, Router} from 'react-router'
import Recherche from './Page/Recherche/'
import Modification from './Page/Modification/'
import Ajout from './Page/Ajout/'
import Dbm from './Page/Dbm/'

export default _ =>
  <Router history={browserHistory}>
    <Route path="/gestion/mercuriale" component={Recherche} name={'produit_mercuriale'}/>
      <Route path="/gestion/ft-base" component={Recherche} name={'produit_base'}/>
      <Route path="/gestion/vente-ft" component={Recherche} name={'produit_vente'}/>
      <Route path="/gestion/vin" component={Recherche} name={'produit_vin'}/>
    <Route path="/gestion/ajout" component={Ajout}/>
    <Route path="/gestion/dbm" component={Dbm}/>
    <Route path="/gestion/:id" component={Modification}/>
  </Router>



// WEBPACK FOOTER //
// ./app/App/Module/Gestion/index.js